import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const KanbanBoardSkeleton = () => {
  return (
    <div>      

      {/* Kanban Columns Skeleton */}
      <div className="p-4 flex space-x-4 overflow-x-auto">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="w-64 sm:w-72 bg-white rounded-lg shadow-md p-3 flex-shrink-0"
          >
            {/* Column Header */}
            <Skeleton height={25} width="70%" className="mb-3" />

            {/* Cards Skeleton */}
            <div className="space-y-2">
              {[...Array(3)].map((_, cardIndex) => (
                <div key={cardIndex} className="p-3 bg-gray-100 rounded-md">
                  <Skeleton height={18} width="60%" />
                  <Skeleton height={12} width="90%" className="mt-2" />
                  <Skeleton height={12} width="80%" className="mt-1" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KanbanBoardSkeleton;
